<script>
import { mapGetters } from "vuex";
import { Btn } from "uiv";
import Resultado from "./Resultado";

export default {
  mixins: [Resultado],
  components: { Btn },
  computed: {
    ...mapGetters(["showConectores",]),
    rules() {
      return this.resultado.tarifa && this.resultado.tarifa.rules[this.getMonedaShow];
    },
  }
};
</script>

<template>
  <div class="thumbnail animated fadeIn">
    <div class="img-bg" :style="{ backgroundImage: `url('${urlFoto}')`}">
      <div class="tarifa" v-if="rules">
        <small v-text="rules.moneda"></small>
        <span v-text="rules.tarifa"></span>
      </div>
    </div>

    <div class="caption">
      <h4 v-html="resultado.nombre"></h4>

      <div class="row">
        <div class="col-xs-12 col-sm-8">
          <ul class="list-inline text-muted">
            <li>
              <b v-html="'C&oacute;digo:'"></b>
              <span v-html="resultado.codigo"></span>
            </li>
            <li v-if="showConectores">
              <b>Proveedor:</b>
              <span v-html="resultado.proveedor_nombre"></span>
            </li>
            <li v-if="showConectores && resultado.operador_nombre">
              <b>Operador:</b>
              <span v-html="resultado.operador_nombre"></span>
            </li>
          </ul>
        </div>
        <div class="col-xs-12 col-sm-4">
          <btn
            :href="resultado.url_reservar"
            size="sm"
            type="warning"
            block
            v-html="'Ver m&aacute;s'"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.thumbnail {
  width: 100%;
  padding: 0;
  border: 0;
  transition-property: box-shadow, opacity;
  overflow-wrap: break-word;
  position: relative;
  white-space: normal;
  overflow: visible;
  transition: box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
  will-change: box-shadow;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
    0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);

  > .img-bg {
    height: 190px;
    position: relative;
    background: no-repeat center #ccc;
    background-size: cover;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;

    > .img-bg-placeholder {
      top: 50%;
      left: 50%;
      color: #a3a3a3;
      width: 80px;
      height: 116px;
      margin: -58px 0 0 -40px;
      font-size: 80px;
      position: absolute;
      text-align: center;
    }

    > .tarifa {
      color: #fff;
      right: 10px;
      bottom: 5px;
      position: absolute;
      font-size: 23px;
      text-align: right;
      text-shadow: 1px 1px 0px #333;
    }
  }
  > .caption {
    padding: 10px;
    > h4 {
      font-size: 16px;
      margin: 0 0 10px;
    }

    > .row {
      margin-right: -5px;
      margin-left: -5px;

      > div {
        padding-right: 5px;
        padding-left: 5px;

        > .list-inline {
          font-size: 11px;
          margin: 0;
          > li {
            padding: 0;
          }
        }
      }
    }
  }
}
</style>